import { Instance } from 'mobx-state-tree';
import { LocationStatusDtoModelBase } from './LocationStatusDtoModel.base';

/* The TypeScript type of an instance of LocationStatusDtoModel */
export interface LocationStatusDtoModelType extends Instance<typeof LocationStatusDtoModel.Type> {}

/* A graphql query fragment builders for LocationStatusDtoModel */
export { selectFromLocationStatusDto, locationStatusDtoModelPrimitives, LocationStatusDtoModelSelector } from './LocationStatusDtoModel.base';

/**
 * LocationStatusDtoModel
 */
export const LocationStatusDtoModel = LocationStatusDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
